/** Registry key for the VhUserAccess entity (mirrors @syscolect/domain VH_USER_ACCESS). */
export const VH_USER_ACCESS = 'VhUserAccess';
//# sourceMappingURL=vhUserAccess.js.map